import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { CurrencyCode, normalizeCurrencyCode } from '@/shared/constants/currencies';
import {
  createCurrencySlice,
  CurrencySlice,
} from '@/features/currency-selector/state/currency-slice';
import { cookieStorage } from '@/shared/helpers/cookie-storage';

export const CURRENCY_STORAGE_KEY = 'wt-currency-storage';

export type CurrencyState = CurrencySlice;

type PersistedState = {
  currentCurrency: CurrencyCode | null;
};

export const useCurrencyStore = create<CurrencyState>()(
  persist(
    (...a) => ({
      ...createCurrencySlice(...a),
    }),
    {
      name: CURRENCY_STORAGE_KEY,
      storage: cookieStorage<PersistedState>(),
      merge: (persistedState, currentState) => {
        const savedState = persistedState as PersistedState | undefined;
        return {
          ...currentState,
          ...savedState,
          currentCurrency: savedState?.currentCurrency
            ? normalizeCurrencyCode(savedState.currentCurrency)
            : currentState.currentCurrency,
        };
      },
      partialize: (state) => ({
        currentCurrency: state.currentCurrency,
      }),
    },
  ),
);
